import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el Aquagym Resuelto después de comprar?',
    a: 'Inmediatamente después de confirmar el pago recibís un email con el link de descarga de todos los PDFs. Acceso en menos de 5 minutos desde cualquier dispositivo.'
  }, {
    q: '¿Sirve para instructores con poca experiencia o solo para los avanzados?',
    a: 'Sirve para todos los niveles. El Tomo 1 está especialmente diseñado para instructores que quieren construir una base sólida, y los siguientes tomos escalan en complejidad de forma gradual.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'Los PDFs están optimizados para lectura y uso al borde de la pileta. Las planillas y fichas incluidas tienen formato editable para que puedas personalizarlas con tus datos.'
  }, {
    q: '¿Los 6 bonos están en las dos ofertas?',
    a: 'Sí. Los 6 bonos estratégicos están incluidos en ambas opciones sin costo extra. El Pack Élite agrega los 2 módulos premium adicionales.'
  }, {
    q: '¿Sirve si doy clases individuales o solo para grupos?',
    a: 'Sirve para ambos. El contenido está adaptado tanto para clases grupales en natatorio como para sesiones individuales o semipersonales.'
  }, {
    q: '¿Sirve si tengo alumnas de distintos niveles al mismo tiempo?',
    a: 'Exactamente para eso fue diseñado. Cada ejercicio incluye variaciones de Nivel 1, Nivel 2 y Nivel 3 para que puedas manejar un grupo heterogéneo con criterio profesional.'
  }, {
    q: '¿Qué diferencia tiene con otros materiales de aquagym?',
    a: 'Es el único sistema en español que combina planificación lista para usar, progresión anual, manejo de poblaciones especiales y gestión del negocio en un solo producto. No hay nada comparable en el mercado hispanohablante.'
  }, {
    q: '¿Por qué elegir el Pack Élite y no el estándar?',
    a: 'Si querés diferenciarte con clases de alta intensidad y además ofrecer un programa de 90 días a tus alumnas — que te permite generar un ingreso extra — el Pack Élite se paga solo con una sola venta a una sola alumna.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si no es lo que esperabas te devolvemos el 100% sin preguntas. Llevamos más de 300 ventas con menos del 1% de devoluciones.'
  }];
  return <section className="py-12 md:py-24 bg-white" data-id="element-114">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-115">
        <FadeIn data-id="element-116">
          <div className="text-center mb-6 md:mb-12" data-id="element-117">
            <h2 className="text-2xl md:text-4xl font-display font-black text-deepblue-900" data-id="element-118">
              Preguntas Frecuentes
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-2 md:space-y-4" data-id="element-119">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-120">
              <div className="border border-slate-200 rounded-xl md:rounded-2xl overflow-hidden bg-white" data-id="element-121">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-3 md:p-6 text-left hover:bg-slate-50 transition-colors" data-id="element-122">
                  <span className="font-bold text-slate-800 pr-4 md:pr-8 text-sm md:text-base" data-id="element-123">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-aqua-600 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-124" />
                </button>

                <AnimatePresence data-id="element-125">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-126">
                      <div className="p-3 md:p-6 pt-0 text-slate-600 border-t border-slate-100 mt-1 md:mt-2 text-sm md:text-base" data-id="element-127">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}